declare global {
  interface JSON {
    parseIfJson(value: string): string
  }
}

JSON.parseIfJson = function (this: JSON, value: string): string {
  try {
    return this.parse(value)
  } catch (e: any){
    return value
  }
};

export default {}
